import { render } from "./SliderItems.vue?vue&type=template&id=716762a5&scoped=true"
import script from "./SliderItems.vue?vue&type=script&lang=js"
export * from "./SliderItems.vue?vue&type=script&lang=js"

import "./SliderItems.vue?vue&type=style&index=0&id=716762a5&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716762a5"]])

export default __exports__